import { CardProps, Stack, Title, Typography } from '@optimus-web/core';
import { Card } from './Card';

interface ContentCardProps {
    title?: React.ReactNode;
    description?: React.ReactNode;
    actions?: React.ReactNode;
}

export const ContentCard: React.FC<React.PropsWithChildren<ContentCardProps & CardProps>> = ({
    title,
    description,
    actions,
    children,
    ...other
}) => (
    <Card {...other}>
        <Stack spacing="200" vertical>
            {title || description || actions ? (
                <Stack distribution="space-between" itemAlignment="start" spacing="200">
                    <Stack vertical style={{ minWidth: 0 }}>
                        {title && (
                            <Title level={2} ellipsis>
                                {title}
                            </Title>
                        )}
                        {description && (
                            <Typography textStyle="bodySmall" variant="secondary" as="div">
                                {description}
                            </Typography>
                        )}
                    </Stack>
                    {actions && <Stack spacing="100">{actions}</Stack>}
                </Stack>
            ) : null}
            {children}
        </Stack>
    </Card>
);
